<particle-flow-chart-designer *ngIf="data.input.section" #flowChartDesigner [section]="data.input.section" [flowChartDataService]="flowChartDataService"
                              [sourceType]="data.input.sourceType"
                              [flowchart]="data.input.flowchart"
></particle-flow-chart-designer>
